import { render, staticRenderFns } from "./batchUploadPerson.vue?vue&type=template&id=259372a0&scoped=true"
import script from "./batchUploadPerson.vue?vue&type=script&lang=js"
export * from "./batchUploadPerson.vue?vue&type=script&lang=js"
import style0 from "./batchUploadPerson.vue?vue&type=style&index=0&id=259372a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259372a0",
  null
  
)

export default component.exports